import template from './filterBar.html';
import '../filterBar.scss';

/**
 * @typedef  {Object}  FilterMap
 * @property {String}  label      the actual display label of the Filter.
 * @property {?String} icon       the icon the filter should display.
 */

/**
 * @typedef  {Object}     Filter
 * @property {String}     name      the name (key) of the Filter.
 * @property {Number}     total     the total amount of Media it will filter.
 * @property {Boolean}    selected  if the filter is selected or not.
 * @property {?FilterMap} map       the extended FilterMap used as a configuration map.
 */

/**
 * @typedef  {Object}  AggregationMap
 * @property {String}  label           the display label of the aggregation.
 * @property {Number}  order           the order in which the aggregation should appear.
 * @property {?String} icon            the icon type to add to the aggregation filters.
 * @property {?String} extraClass      the extra class to add to the aggregation.
 */

/**
 * @typedef  {Object}          Aggregation
 * @property {String}          key          the key of the aggregation.
 * @property {Boolean}         expanded     if the aggregation is expanded or not.
 * @property {Array}           values       the list of available {@link Filter}.
 * @property {?AggregationMap} map          the extended AggregationMap used as a configuration map.

/**
 * @ngdoc controller
 * @name OdsFilterBar
 * @description
 * This component renders the filter bar.
 */
class OdsFilterBar {
  constructor() {
    /**
     * Flag that indicates if the filter bar is visible or not.
     * @type {Boolean}
     */
    this.isVisible = true;
  }
  /**
   * Change the visibility of the filter bar.
   */
  onVisibilityToggle() {
    this.isVisible = !this.isVisible;
  }
  /**
   * Change the expanded status of an aggregation.
   *
   * @param {Object} aggregation  the aggregation to change the expanded status.
   */
  toggleAggregationExpansion(aggregation) {
    aggregation.expanded = !aggregation.expanded;
  }
}

/**
 * @ngdoc component
 * @name odsFilterBar
 * @description
 * The filter bar component.
 */
export default {
  /**
   * The controller class for the component.
   * @type {OdsFilterBar}
   */
  controller: OdsFilterBar,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {Array}    aggregations    the aggregations to be displayed.
   * @property {Function} onFilterChange  callback when a filter is changed.
   */
  bindings: {
    aggregations: '<',
    onFilterChange: '&',
  },
  transclude: {
    top: '?odsFilterBarTop',
    bottom: '?odsFilterBarBottom',
  }
};
